export const LOAD_MESSAGES = 'load_messages';
export const MESSAGES_LOADED = 'messages_loaded';
export const MESSAGE_DELETED = 'message_deleted';
export const MESSAGE_ADDED = 'message_added';
export const SAVE_MESSAGE = 'save_message';
export const MESSAGE_SAVED = 'message_saved';
export const LOAD_MESSAGE_TYPES = 'load_message_types';
export const MESSAGE_TYPES_LOADED = 'message_type_loaded';
export const SYNCING = 'syncing';
export const SYNC_FAILED = 'messages_sync_failed';
export const CONTROL_MESSAGE_POPUP = 'control_message_popup';
export const RESET_MESSAGE_ERROR = 'reset_message_error';
